import script from "./InsuranceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InsuranceForm.vue?vue&type=script&setup=true&lang=js"

import "./InsuranceForm.vue?vue&type=style&index=0&id=6b399c66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b399c66"]])

export default __exports__